/* eslint-disable no-use-before-define,jsx-a11y/anchor-is-valid */
import React from 'react'
import { fmt, show, hideModal } from '../../twd'

export default ({rows, from}) => (
    <div className="table-responsive">
    <table
        data-name="offerings-modal-table"
        className="table align-top">
        <thead>
        <tr>
        <th>CUSIP</th>
        <th>Maturity date</th>
        <th>Price</th>
        <th>Coupon</th>
        <th>Yield</th>
        <th>Moody's</th>
        <th>S&amp;P</th>
        <th>Action</th>
        </tr>
    </thead>
    <tbody>{
        rows && rows.map( (r,i) => {
            return <tr
                data-name="offerings-modal-row"
                key={i}>
            <td className="text-bold"><a href='#'
                type="button"
                data-name="offerings-modal-cusip-link"
                style={{cursor:'pointer'}}
                onClick={() => {
                    hideModal()
                    show('bond-detail', { cusip: r.holdCusip, from })
                }}
            >{r.holdCusip}</a></td>
            <td>{r.holdMaturity}</td>
            <td>{fmt.price(r.askPrice)}</td>
            <td>{fmt.cpn(r.holdCoupon)}</td>
            <td>{fmt.ytw(r.askYield)}</td>
            <td>{r.moodyRating || fmt.empty()}</td>
            <td>{r.spRating || fmt.empty()}</td>
            <td>{fmt.buy({cusip:r.holdCusip, from})}</td>
            </tr>
        })
    }</tbody>
    </table>
    </div>)
